/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ResultComponent from 'cio/components/newsletters/results';

import { Measure, Entities } from 'cio/utils/metrics/common';
import { Metric, summarizeMetrics } from 'cio/utils/metrics/models/metric';
import { capitalize } from '@ember/string';

interface MetricHeader {
  label: string;
  metric: Measure;
}

// This component is inheriting from its parent for DRY reasons
// because it shares some code with LanguageMetrics component.
export default class LanguageMetrics extends ResultComponent {
  get hasMultipleTestGroups() {
    return this.testGroupIds.length > 1;
  }

  get metricsTotal(): Metric {
    let metricsToSummarize = this.templates.map((template) => {
      return this.metricsByTemplateId[template.id];
    });
    return summarizeMetrics(this.args.newsletter.id, Entities.NEWSLETTER, null, metricsToSummarize);
  }

  get metricHeaders(): MetricHeader[] {
    let denominator: Measure = this.environment.current.metricDenominator;

    if (!this.args.newsletter?.channelInfo.metrics.includes(denominator)) {
      denominator = 'sent';
    }

    return [
      {
        label: capitalize(denominator),
        metric: denominator,
      },
      {
        label: 'Opened',
        metric: 'opened',
      },
      {
        label: 'Clicked',
        metric: 'clicked',
      },
      {
        label: 'Converted',
        metric: 'converted',
      },
      {
        label: 'Unsubscribed',
        metric: 'unsubscribed',
      },
      {
        label: 'Marked as spam',
        metric: 'spammed',
      },
    ];
  }

  get visibleMetricHeaders(): MetricHeader[] {
    return this.metricHeaders.filter((header) => this.args.newsletter?.channelInfo.metrics.includes(header.metric));
  }
}
